<template lang="pug">
BriqRadio(
  data-test-id="more-than-two-segments-mix-options"
  label="Mixed bookings"
  description="How would you like Briq to handle mixed bookings; eg. bookings that contain both children and adults?"
  :hide-optional-marker="true"
  :options="options"
  v-model="mixBookingsOptionSelected"
  :disabled="disabled"
  )
</template>

<script>
export default {
  name: 'MoreThanTwoSegmentsMixOptions',
  props: {
    value: { type: Boolean, default: true },
    disabled: Boolean,
    totalSelectedActiveSegments: Number,
  },
  data() {
    return {
      options: {
        mix: 'Mixing segments in a time slot',
        noMix: 'No mixing segments in a time slot',
      },
    }
  },
  computed: {
    mixBookingsOptionSelected: {
      get() {
        return this.value ? 'mix' : 'noMix'
      },
      set(v) {
        this.$emit('input', v === 'mix')
      },
    },
  },
}
</script>
